import BaseAbility from 'umg-ember-backend/abilities/base';

export default class AssetAbility extends BaseAbility {}
